import { getStoredQueryParam } from "@/utils/queryParams";
import { OnboardingStep } from "../onboarding/types";
import { FlowConfig } from "./types";

export const computeProgress = (
  flowConfig: FlowConfig | undefined,
  currentStep: OnboardingStep,
): number => {
  if (currentStep.type === "disqualification") {
    return 1;
  }

  const hasEmailStep = getStoredQueryParam("collect_email") !== undefined;

  if (flowConfig?.progressPath.length) {
    const totalSteps = flowConfig.progressPath.length + (hasEmailStep ? 1 : 0);
    const index = flowConfig.progressPath.indexOf(currentStep.id);
    if (index !== -1) {
      return (index + 1) / totalSteps;
    }
    if (
      flowConfig.treatmentArea === "OBESITY" &&
      hasEmailStep &&
      currentStep.id === "emailCollection"
    ) {
      return 1;
    }

    if (flowConfig.alternativeProgressPath) {
      const altIndex = flowConfig.alternativeProgressPath.indexOf(currentStep.id);
      if (altIndex !== -1) {
        const altTotalSteps = flowConfig.alternativeProgressPath.length + (hasEmailStep ? 1 : 0);
        return (altIndex + 1) / altTotalSteps;
      }
    }
  }

  return currentStep.flowProgress || 0;
};
